module.exports = __webpack_public_path__ + "img/capa-juntos-12.4ef11f79.png";